module.exports = __webpack_public_path__ + "static/media/wc.7ae74ba8.png";